(function (algolia, addPriceInputs) {
  const client = algolia.externals.algoliasearch(
    algolia.config.app_id,
    algolia.config.search_api_key
  );
  const index = client.initIndex(algolia.config.index_prefix + 'products');
  class QuickViewPriceInputs {
    variantSelects;
    form;
    variants;
    algoliaIndex;
    addPriceInputs;

    constructor(algoliaIndex, addPriceInputs) {
      this.algoliaIndex = algoliaIndex;
      this.addPriceInputs = addPriceInputs;
      this.form = document.querySelector('.product-form form');
      this.variantSelects = document.querySelectorAll('variant-selects select');

      for (const variantSelect of this.variantSelects) {
        variantSelect.addEventListener('change', this.onVariantChange);
      }

      this.getVariants();
    }

    async getVariants() {
      const variantSelectsEl = document.querySelector('variant-selects');
      let variantIds = [document.querySelector('[name="id"]').value];

      if(!!variantSelectsEl) {
        variantIds = variantSelectsEl.dataset.variantIds.split(',');
      }

      const { results } = await this.algoliaIndex.getObjects(variantIds);
      this.variants = results;

      /**
       * Wait until variant data has been retrieved before re-enabling
       * variant options and the add to cart button so that discounts
       * can be properly applied when adding a product to cart
       */
      for (const variantSelect of this.variantSelects) {
        variantSelect.removeAttribute('disabled');
      }

      const addBtn = this.form.querySelector('#AddToCartButton');
      if (addBtn.dataset.unavailable == 'false') {
        addBtn.removeAttribute('disabled');
      }
    }

    getVariantByTitle(title) {
      for (const variant of this.variants) {
        if (variant.variant_title === title) {
          return variant;
        }
      }

      throw new Error(`Variant "${title}" is not found`);
    }

    onVariantChange = e => {
      const variantTitle = e.target.value;
      const variant = this.getVariantByTitle(variantTitle);
      this.addPriceInputs(this.form, variant);

      // Update the Recharge widget for the new variant
      const rechargeWidget = window.ReChargeWidget.getWidgetByProductId(variant.id);
      if (rechargeWidget) {
        rechargeWidget.update({ productId: variant.id });
      }
    }
  }

  class QuickViewModal extends ModalDialog {
    content;

    constructor() {
      super();
      this.content = document.getElementById('quick-view-modal-content');
    }

    hide() {
      super.hide();
      this.content.innerHTML = '';
    }

    show(opener) {
      super.show(opener);
      this.renderProductInfo();
    }

    renderProductInfo() {
      const handle = this.openedBy.dataset.handle;
      fetch(`/products/${handle}?view=quick-view`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const quickViewContent = html.getElementById('quick-view-template');

          if (quickViewContent && this.content) {
            this.content.innerHTML = quickViewContent.innerHTML;
            const productForm = this.content.querySelector('#product-form-QuickView');
            if (!productForm) return;

            // Add Recharge Widget
            this.addRechargeWidget(productForm); 
          }

          new QuickViewPriceInputs(index, addPriceInputs);

          if (!window.yotpo) return;
          window.yotpo.initWidgets();
        });
    }

    addRechargeWidget(productForm) {
      const productId = productForm.getAttribute('data-productid');
      if (!productId) return;

      const rechargeWidgetContainer = productForm.querySelector('#recharge-widget-container');

      const config = {
        productId: productId,
        injectionParent: rechargeWidgetContainer,
        injectionMethod: 'prepend',
        selectors: {
          price: ['#product-form-QuickView .product__price'], 
          variant: ['#product-form-QuickView select'] 
        }
      };

      window.ReChargeWidget.createWidget(config);

      // Dynamically Update Discount Percentage Based on Selected Selling Plan
      const observer = new MutationObserver((mutationsList, observer) => {
        const discountLabel = productForm.querySelector('.rc-option__discount');
        const planDropdown = productForm.querySelector('.rc_widget__option__plans__dropdown');

        if (discountLabel && planDropdown) {
          const updateDiscountLabel = () => {
            const selectedOption = planDropdown.options[planDropdown.selectedIndex];
            const discountText = selectedOption.dataset.planOption.match(/(\d+)% discount/);

            if (discountText && discountText[1]) {
              discountLabel.textContent = discountText[1] + '%';
            } else {
              discountLabel.textContent = '';
            }
          };

          updateDiscountLabel(); // Initial update
          planDropdown.addEventListener('change', updateDiscountLabel);

          observer.disconnect(); // Stop observing once elements are found
        }
      });

      observer.observe(rechargeWidgetContainer, { childList: true, subtree: true });

    }
  }

  customElements.define('quick-view-modal', QuickViewModal);

})(window.algoliaShopify, window.addPriceInputs);
